import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { ErrorHandler, NgModule, inject, provideAppInitializer } from '@angular/core'
import { ModalModule } from 'ngx-bootstrap/modal'
import { providePrimeNG } from 'primeng/config'
import BidrPreset from '../styles/primeng-bidr-preset'
import { TraceService, createErrorHandler } from '@sentry/angular'

// modules
import { SharedModule } from 'app/shared/shared.module'
import { AppRoutingModule } from 'app/app-routing.module'
import { CoreModule } from 'app/core/core.module'

// components
import { AppComponent } from './app.component'
import { UnauthorizedComponent } from './unauthorized/unauthorized.component'
import { ForbiddenComponent } from './forbidden/forbidden.component'
import { ErrorComponent } from './error/error.component'
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { AuthConfigModule } from './auth-config.module'
import { AbstractSecurityStorage } from 'angular-auth-oidc-client'
import { AuthLocalStorageService } from './core/services/auth-local-storage.service'
import { StartupClass } from './core/services/app-loader.service'
import { AppConfigurationService } from './core/services/app-configuration.service'
import { UrlService } from './core/services/url.service'
import { Router } from '@angular/router'

@NgModule({
  declarations: [
    AppComponent,
    UnauthorizedComponent,
    ForbiddenComponent,
    ErrorComponent,
  ],
  bootstrap: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AuthConfigModule,
    ModalModule.forRoot(),
    AppRoutingModule,
    SharedModule.forRoot(),
    CoreModule,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useFactory: () => createErrorHandler({ showDialog: false }),
    },
    {
      provide: TraceService,
      deps: [Router],
    },
    provideAppInitializer(() => {
      const startup = inject(StartupClass);
      inject(UrlService);
      inject(AppConfigurationService);
      inject(TraceService);
      return startup.load();
    }),

    providePrimeNG({
      ripple: true,
      theme: {
        preset: BidrPreset,
        options: { darkModeSelector: 'none' },
      },
    }),

    { provide: AbstractSecurityStorage, useClass: AuthLocalStorageService },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}